module.exports = __webpack_public_path__ + "eb15143daab78ea16e2e184f7a1bd53f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_AGE_GATE_BG.jpg
// module id = 391
// module chunks = 0